// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { DocumentDetails_EntityFragment, DocumentDetails_TestamentaryEntityFragment } from '../../../../modules/documents/graphql/DocumentDetails.generated';
import { gql } from '@apollo/client';
import { DocumentDetails_EntityFragmentDoc, DocumentDetails_TestamentaryEntityFragmentDoc } from '../../../../modules/documents/graphql/DocumentDetails.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DocumentEntityAssociationUpdatesQueryVariables = Types.Exact<{
  documentID: Types.Scalars['ID']['input'];
}>;


export type DocumentEntityAssociationUpdatesQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', edges?: Array<{ __typename?: 'DocumentEdge', node?: { __typename?: 'Document', id: string, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, entity?: (
                { __typename?: 'Entity' }
                & DocumentDetails_EntityFragment
              ) | null, testamentaryEntity?: (
                { __typename?: 'TestamentaryEntity' }
                & DocumentDetails_TestamentaryEntityFragment
              ) | null } | null } | null> | null } } | null } | null> | null } };

export const Operations = {
  Query: {
    DocumentEntityAssociationUpdates: 'DocumentEntityAssociationUpdates' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DocumentEntityAssociationUpdatesDocument = gql`
    query DocumentEntityAssociationUpdates($documentID: ID!) {
  documents(where: {id: $documentID}) {
    edges {
      node {
        id
        entityDocumentRelationships {
          edges {
            node {
              id
              relationshipType
              entity {
                ...DocumentDetails_Entity
              }
              testamentaryEntity {
                ...DocumentDetails_TestamentaryEntity
              }
            }
          }
        }
      }
    }
  }
}
    ${DocumentDetails_EntityFragmentDoc}
${DocumentDetails_TestamentaryEntityFragmentDoc}`;

/**
 * __useDocumentEntityAssociationUpdatesQuery__
 *
 * To run a query within a React component, call `useDocumentEntityAssociationUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentEntityAssociationUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentEntityAssociationUpdatesQuery({
 *   variables: {
 *      documentID: // value for 'documentID'
 *   },
 * });
 */
export function useDocumentEntityAssociationUpdatesQuery(baseOptions: Apollo.QueryHookOptions<DocumentEntityAssociationUpdatesQuery, DocumentEntityAssociationUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentEntityAssociationUpdatesQuery, DocumentEntityAssociationUpdatesQueryVariables>(DocumentEntityAssociationUpdatesDocument, withFetchPolicyContext(options));
      }
export function useDocumentEntityAssociationUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentEntityAssociationUpdatesQuery, DocumentEntityAssociationUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentEntityAssociationUpdatesQuery, DocumentEntityAssociationUpdatesQueryVariables>(DocumentEntityAssociationUpdatesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDocumentEntityAssociationUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DocumentEntityAssociationUpdatesQuery, DocumentEntityAssociationUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentEntityAssociationUpdatesQuery, DocumentEntityAssociationUpdatesQueryVariables>(DocumentEntityAssociationUpdatesDocument, withFetchPolicyContext(options));
        }
export type DocumentEntityAssociationUpdatesQueryHookResult = ReturnType<typeof useDocumentEntityAssociationUpdatesQuery>;
export type DocumentEntityAssociationUpdatesLazyQueryHookResult = ReturnType<typeof useDocumentEntityAssociationUpdatesLazyQuery>;
export type DocumentEntityAssociationUpdatesSuspenseQueryHookResult = ReturnType<typeof useDocumentEntityAssociationUpdatesSuspenseQuery>;
export type DocumentEntityAssociationUpdatesQueryResult = Apollo.QueryResult<DocumentEntityAssociationUpdatesQuery, DocumentEntityAssociationUpdatesQueryVariables>;